import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=594bb029&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"
import style0 from "./Business.vue?vue&type=style&index=0&id=594bb029&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594bb029",
  null
  
)

export default component.exports